export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP = "https://wa.me/918692947656?text=" +
  encodeURIComponent("Hi Catalyst Crew! I just played the Content Calendar game and want better strategy & execution for my business.");
export const EMAIL = "mailto:contact@catalystcrew.in?subject=" + encodeURIComponent("Content strategy for my business");
export const SITE = "https://www.catalystcrew.in";
export const LOGO = "/catalyst-crew-logo.svg";
export const IG_HANDLE = "@the.catalyst.crew";

export const FORMAT_STYLES = {
  Reel: { bg: "#ffd84f", fg: "#102e24", label: "Reel" },
  Carousel: { bg: "#f6a5c0", fg: "#3b1022", label: "Carousel" },
  Story: { bg: "#b9e3d0", fg: "#102e24", label: "Story" },
  Post: { bg: "#c7d2fe", fg: "#1e1b4b", label: "Post" },
  Live: { bg: "#fdba74", fg: "#431407", label: "Live" },
};
